(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2201],{

/***/ 14036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k1": function() { return /* binding */ useHubspotForm; },
/* harmony export */   "l0": function() { return /* binding */ HubspotProvider; }
/* harmony export */ });
/* unused harmony exports HubSpotFormLocale, useHubspotContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * Locales supported by HubSpot forms
 */
var HubSpotFormLocale;
(function (HubSpotFormLocale) {
    /**
     * English
     */
    HubSpotFormLocale["ENGLISH"] = "en";
    /**
     * Danish
     */
    HubSpotFormLocale["DANISH"] = "da";
    /**
     * German
     */
    HubSpotFormLocale["GERMAN"] = "de";
    /**
     * Spanish (Spain)
     */
    HubSpotFormLocale["SPANISH"] = "es";
    /**
     * Spanish (Mexico)
     */
    HubSpotFormLocale["SPANISH_MEXICO"] = "es-mx";
    /**
     * Finnish
     */
    HubSpotFormLocale["FINNISH"] = "fi";
    /**
     * French
     */
    HubSpotFormLocale["FRENCH"] = "fr";
    /**
     * Italian
     */
    HubSpotFormLocale["ITALIAN"] = "it";
    /**
     * Japanese
     */
    HubSpotFormLocale["JAPANESE"] = "ja";
    /**
     * Dutch
     */
    HubSpotFormLocale["DUTCH"] = "nl";
    /**
     * Polish
     */
    HubSpotFormLocale["POLISH"] = "pl";
    /**
     * Portuguese
     */
    HubSpotFormLocale["PORTUGUESE"] = "pt-br";
    /**
     * Swedish
     */
    HubSpotFormLocale["SWEDISH"] = "sv";
    /**
     * Chinese
     */
    HubSpotFormLocale["CHINESE"] = "zh-cn";
    /**
     * Chinese (Hong Kong)
     */
    HubSpotFormLocale["CHINESE_HONG_KONG"] = "zh-hk";
})(HubSpotFormLocale || (HubSpotFormLocale = {}));

// Hook
var cachedScripts = [];
function useScript(src, async, addToHead) {
    if (async === void 0) { async = true; }
    if (addToHead === void 0) { addToHead = false; }
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), loaded = _a[0], setLoaded = _a[1];
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), error = _b[0], setError = _b[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        // If cachedScripts array already includes src that means another instance ...
        // ... of this hook already loaded this script, so no need to load again.
        if (cachedScripts.includes(src)) {
            setLoaded(true);
            setError(false);
        }
        else {
            cachedScripts.push(src);
            // Create script
            var script_1 = document.createElement('script');
            script_1.src = src;
            script_1.async = async;
            // Script event listener callbacks for load and error
            var onScriptLoad_1 = function () {
                setLoaded(true);
                setError(false);
            };
            var onScriptError_1 = function () {
                // Remove from cachedScripts we can try loading again
                var index = cachedScripts.indexOf(src);
                if (index >= 0) {
                    cachedScripts.splice(index, 1);
                }
                script_1.remove();
                setLoaded(true);
                setError(true);
            };
            script_1.addEventListener('load', onScriptLoad_1);
            script_1.addEventListener('error', onScriptError_1);
            // Add script to document head if required, otherwise to the body
            addToHead
                ? document.head.appendChild(script_1)
                : document.body.appendChild(script_1);
            // Remove event listeners on cleanup
            return function () {
                script_1.removeEventListener('load', onScriptLoad_1);
                script_1.removeEventListener('error', onScriptError_1);
            };
        }
    }, [src]); // Only re-run effect if script src changes
    return [loaded, error];
}

var HubspotContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    loaded: false,
    error: false
});
var useHubspotContext = function () { return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(HubspotContext); };
var HubspotProvider = function (_a) {
    var async = _a.async, addToHead = _a.addToHead, children = _a.children;
    // Attach hubspot script to the document
    var _b = useScript('https://js.hsforms.net/forms/v2.js', async, addToHead), loaded = _b[0], error = _b[1];
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(HubspotContext.Provider, { value: { loaded: loaded, error: error } }, children));
};

var useHubspotForm = function (props) {
    var _a = useHubspotContext(), loaded = _a.loaded, error = _a.error;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), formCreated = _b[0], setFormCreated = _b[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (typeof window !== 'undefined' && window) {
            var windowWithHubspot = window;
            if (loaded && windowWithHubspot.hbspt && !formCreated) {
                windowWithHubspot.hbspt.forms.create(props);
                setFormCreated(true);
            }
        }
    }, [loaded, formCreated, setFormCreated]);
    return { loaded: loaded, formCreated: formCreated, error: error };
};




/***/ }),

/***/ 12375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var src_components_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26718);
/* harmony import */ var src_components_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71033);
/* harmony import */ var _aaronhayes_react_use_hubspot_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14036);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







const ContattiPage = () => {
  (0,_aaronhayes_react_use_hubspot_form__WEBPACK_IMPORTED_MODULE_1__/* .useHubspotForm */ .k1)({
    portalId: "6886918",
    formId: "289e0dc9-27fb-4ef2-81a9-cac6f7637972",
    target: '#contattaci-form'
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
    bgColor: "baseBackgroundLight",
    mt: "m",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
      maxW: "6xl",
      pt: "0",
      pb: "xxl",
      mx: "auto",
      px: "m",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        title: "Contattaci"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_5__/* .LinkRel */ .M, {
        rel: "canonical",
        href: "https://www.carplanner.com/contatti"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
        fontSize: "1.75rem",
        fontFamily: "Montserrat-SemiBold",
        color: "baseDark",
        textAlign: "left",
        children: "Contattaci"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
        textAlign: "left",
        children: ["Compila il form con i tuoi dati per ricevere maggiori informazioni.", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("br", {}), "Un nostro consulente ti contatter\xE0 al pi\xF9 presto!"]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
        id: "contattaci-form",
        mt: "-1rem",
        fontFamily: "Montserrat-Medium",
        textAlign: "left",
        my: "xxl"
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (ContattiPage);

/***/ }),

/***/ 26718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18132);
/* harmony import */ var src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34755);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







const Head = _ref => {
  let {
    title
  } = _ref;
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("title", {
      children: [title || t('common:header.title'), ' ', "| CarPlanner"]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-Regular.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-Medium.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-SemiBold.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .image */ .BH
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .boxes[0].image */ .qk[0].image
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .boxes[1].image */ .qk[1].image
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Head);

/***/ }),

/***/ 71033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ LinkRel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const isMetaTag = value => {
  if (!value || typeof value !== 'object') return false;
  const tag = value;
  const hasNameOrProperty = typeof tag.name === 'string' || typeof tag.property === 'string';
  if (!hasNameOrProperty) return false;
  const contentOk = tag.content === undefined || typeof tag.content === 'string';
  const overrideOk = tag.override === undefined || typeof tag.override === 'string';
  return contentOk && overrideOk;
};

const normalizeMeta = meta => {
  if (!meta) return [];

  if (Array.isArray(meta)) {
    return meta.filter(isMetaTag);
  }

  if (isMetaTag(meta)) {
    return [meta];
  }

  if (typeof meta === 'object') {
    return Object.values(meta).filter(isMetaTag);
  }

  return [];
};

const MetaTags = _ref => {
  let {
    meta
  } = _ref;
  const tags = normalizeMeta(meta);
  if (tags.length === 0) return null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: tags.map((tag, index) => {
      const content = tag.override && tag.override.trim() !== '' ? tag.override : tag.content ?? '';
      const key = tag.name ?? tag.property ?? `meta-${index}`;

      if (tag.name) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
          name: tag.name,
          content: content
        }, key);
      }

      if (tag.property) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
          property: tag.property,
          content: content
        }, key);
      }

      return null;
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);
const LinkRel = _ref2 => {
  let {
    rel,
    href,
    crossOrigin,
    type,
    as
  } = _ref2;
  let url = '';

  if (rel === 'canonical' && href.indexOf('?') >= 0) {
    // rimuove eventuali parametri querystring
    url = href.split('?')[0] ?? '';
  } else {
    url = href;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: rel,
      href: url,
      crossOrigin: crossOrigin || null,
      type: type || null,
      as: as || null
    })
  });
};

/***/ }),

/***/ 40658:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contatti",
      function () {
        return __webpack_require__(12375);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34755:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"TN":"Lasciati guidare verso\\nla scelta dell’auto migliore","BH":"https://static1.carplanner.com/website/assets/index-head.jpg","Oc":"CarPlanner ti propone le offerte di auto nuove più competitive\\nsul mercato sia per l’acquisto che per il Noleggio a Lungo Termine","qk":[{"image":"https://static1.carplanner.com/website/assets/noleggia-la-tua-auto-a-lungo-termine-2.png","title":"Noleggia la tua auto a lungo termine","description":"Cerchi un’alternativa all’acquisto di un’auto?","action":"Scopri di più","actionMobile":"Scopri","href":"/noleggio-a-lungo-termine","alt":"Offerte noleggio a lungo termine","target":"_self"},{"image":"https://static1.carplanner.com/website/assets/acquista-la-tua-nuova-auto-online-2.png","title":"Acquista la tua nuova auto online","description":"Cerchi la tua\\nnuova auto?","action":"Scopri di più","actionMobile":"Scopri","href":"/offerte-auto","alt":"Offerte auto in vendita","target":"_self"}],"PX":{"a":"Contattaci ora"}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(40658); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);